import * as React from 'react';
import Ribbon from './Ribbon';
import RibbonPlugin from '../plugin/RibbonPlugin';
import RibbonViewState from '../store/schema/RibbonViewState';
import fontName from './buttons/fontName';
import fontSize from './buttons/fontSize';
import bold from './buttons/bold';
import italic from './buttons/italic';
import underline from './buttons/underline';
import backColor from './buttons/backColor';
import textColor from './buttons/textColor';
import setIsContextualFormatBarShown from '../actions/setIsContextualFormatBarShown';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { PluginUIProps } from 'owa-editor/lib/store/schema/PluginWithUI';
import { Callout, DirectionalHint } from 'office-ui-fabric-react/lib/Callout';
import { observer } from 'mobx-react';

const CONTEXTUAL_FORMAT_BAR_BUTTONS = [
    fontName,
    fontSize,
    bold,
    italic,
    underline,
    backColor,
    textColor,
];

const styles = require('./ContextualFormatBar.scss');

@observer
export default class ContextualFormatBar extends React.Component<
    PluginUIProps<RibbonViewState, RibbonPlugin>,
    {}
> {
    private formatBarDiv: HTMLElement;
    private suspendDismissOnce: boolean;

    render() {
        let { plugin, viewState } = this.props;
        let {
            isContextualFormatBarShown,
            contextualFormatBarLeft,
            contextualFormatBarTop,
        } = viewState;

        return (
            isContextualFormatBarShown && (
                <Callout
                    gapSpace={10}
                    isBeakVisible={false}
                    target={{ x: contextualFormatBarLeft, y: contextualFormatBarTop }}
                    directionalHint={DirectionalHint.topLeftEdge}
                    directionalHintForRTL={DirectionalHint.topRightEdge}
                    onDismiss={this.onDismiss}>
                    <div ref={ref => (this.formatBarDiv = ref)}>
                        <Ribbon
                            className={styles.contextualFormatBar}
                            ribbonPlugin={plugin}
                            viewState={viewState}
                            skipInitialResize={true}
                            isDarkMode={plugin.getEditor().isDarkMode()}
                            buttons={CONTEXTUAL_FORMAT_BAR_BUTTONS}
                            onDropDownDismissed={this.onDropDownDismissed}
                            focusToButtonBeforeDropDown={true}
                            isRtl={getUserConfiguration().SessionSettings.IsUserCultureRightToLeft}
                        />
                    </div>
                </Callout>
            )
        );
    }

    private onDismiss = (evt: any) => {
        // Do not dismiss if clicking on buttons inside contextual format bar
        let target =
            evt instanceof FocusEvent && evt.relatedTarget instanceof Node
                ? evt.relatedTarget
                : null;
        let clickOnRibbon = target && this.formatBarDiv && this.formatBarDiv.contains(target);
        if (!clickOnRibbon && !this.suspendDismissOnce) {
            setIsContextualFormatBarShown(this.props.viewState, false /*isShown*/);
        }
        this.suspendDismissOnce = false;
    };

    private onDropDownDismissed = () => {
        this.suspendDismissOnce = true;
    };
}
